/**
 * Bloc Base JS
 */

jQuery(document).ready(function($){

});


// HEADER ACADÉMIQUE / DÉPARTEMENT
// Détecte si le titre du site se brise sur plusieurs lignes et
// ajuste l'alignement vertical du groupe en conséquence.
document.querySelectorAll('.header-uqam_range1').forEach(rangee => {
	const titre = rangee.querySelector('.wp-block-site-title');
	const groupe = rangee.querySelector(':scope > .wp-block-group');

	if (!titre || !groupe) return;

	// Compare la hauteur réelle du titre à celle d'une seule ligne pour détecter le retour à la ligne.
	function mettreAJourAlignement() {
		const hauteurLigne = parseFloat(getComputedStyle(titre).lineHeight);
		const estSurPlusieursLignes = titre.offsetHeight > hauteurLigne * 1.5;
		groupe.classList.toggle('titre-multi-lignes', estSurPlusieursLignes);
	}

	new ResizeObserver(mettreAJourAlignement).observe(titre);
	mettreAJourAlignement();
});


// PAGE PROGRAMMES
// Temporaire en attendant que le contenu vienne de FUSION
if (document.querySelector('.wp-block-sav-uqam-filtres-programme')) {
	document.addEventListener('filters-updated', (event) => {
		const programmes = document.querySelectorAll('.post-type-archive-programmes .wp-block-post.programmes');
		programmes.forEach(programme => {
			const urlChamp = programme.querySelector(".wp-block-mfb-meta-field-block.d-none .value");
			const url = urlChamp ? urlChamp.textContent.trim() : null;
			const postProgramme = programme.querySelector(".wp-block-post>.wp-block-group");
			if (postProgramme && url) {
				const link = document.createElement("a");
				link.href = url;
				postProgramme.parentNode.insertBefore(link, postProgramme);
				link.appendChild(postProgramme);
			}
			// Enlever les liens sur Type et Cycles
			const typeCycleLinks = programme.querySelectorAll(".taxonomy-type_programme a, .taxonomy-cycle a");
			typeCycleLinks.forEach(a => {
				const span = document.createElement("span");
				span.textContent = a.textContent;
				a.replaceWith(span);
			});
		})
	});
}
